import { state } from "state";
import { Controller } from "stimulus";

import { reloadCalendarViews } from "controllers/calendar_helpers";

export default class extends Controller {
  static values = { fetchQueryParams: String };

  connect() {
    state.fetchQueryParams = this.fetchQueryParamsValue;
    reloadCalendarViews();
  }
}
